import API from "./API";
import qs from "qs";
import config from "@/config";

class OAuth {
  static async getClientToken(oauthToken, scope) {
    const headers = {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: `Basic ${oauthToken}` // base64("hostname:ipratico")
    };

    return API.post(
      `${config.authURL}/oauth2/token`,
      qs.stringify({
        grant_type: "client_credentials",
        scope: scope
      }),
      {
        headers
      }
    );
  }
}

export default OAuth;
